import React, { useMemo } from "react";

import { Car } from "../../../../../../services";
import { CellContentRoot } from "../../../../../LightTable";

const MarkCellContent: React.FC<MarkCellContent.Props> = ({ item }) => {
	const content = useMemo(
		() => item.model?.carBaseTypeToCarBrand?.carBrand?.name || "",
		[item.model?.carBaseTypeToCarBrand?.carBrand?.name],
	);

	return (
		<CellContentRoot alignItems="center" w="100%" h="100%">
			{content}
		</CellContentRoot>
	);
};

declare namespace MarkCellContent {
	interface Props {
		item: Car.Model;
	}
}

export default MarkCellContent;
